import { useEffect, useRef, useState } from 'react';
import { Button, Grid, theme } from 'antd';
import { SignatureDrawerIndexes } from '../../../constants';
import { t } from '../../../util';
import { getCanvasDimensions } from '../../../util/canvas';
import { canvasDimesions, SignatureType } from '../constants';
import ESignatureCanvas from '../ESignatureCanvas';
import { SaveSignatureEvent } from '../SaveSignatureEvent';
import {
	StyledClearSignature,
	StyledMessage,
	StyledSignatureCanvasWrapper,
} from './ESignaturePad.styled';

const { useBreakpoint } = Grid;

export const ESignaturePad = ({
	saveSignature,
	penColor,
	isSignatureDrawn,
	setIsSignatureDrawn,
	tabOpened = SignatureType.DRAWN,
	clearRef = undefined,
	isSignerFlow = false,
	previousValue = undefined,
	setPreviousValue = undefined,
	dimensions,
}) => {
	const { token } = theme.useToken();
	const screens = useBreakpoint();
	const canvasRef = useRef(null);

	const clearSignature = () => {
		canvasRef.current.clear();
		setIsSignatureDrawn(false);
	};

	const onSignEnd = () => {
		setIsSignatureDrawn(true);
	};

	const { canvasWidth, canvasHeight } = getCanvasDimensions(
		dimensions.MAX_WIDTH,
		dimensions.SIDE_PADDING,
		screens
	);

	useEffect(() => {
		const canvasRefValue = canvasRef.current;

		if (
			isSignerFlow &&
			canvasRefValue &&
			previousValue?.signature_type === SignatureType.DRAWN
		) {
			canvasRefValue.fromData(JSON.parse(previousValue.json_data));
			setPreviousValue(null);
		}

		if (isSignerFlow && tabOpened === SignatureType.DRAWN) {
			canvasRefValue?.isEmpty() ? setIsSignatureDrawn(false) : setIsSignatureDrawn(true);
		}

		const onSaveEventHandler = () => {
			if (
				canvasRefValue &&
				(!isSignerFlow || (isSignerFlow && tabOpened === SignatureType.DRAWN))
			) {
				const canvasToSave = canvasRefValue.getCanvasToSave();
				const signatureDataUrl = canvasToSave.toDataURL('image/png');
				const data = canvasRefValue.toData();

				if (data.length > 0) {
					saveSignature(signatureDataUrl, JSON.stringify(data), null);
				}
			}
		};

		const key = 'ESignaturePad';
		SaveSignatureEvent.registerHandler(key, onSaveEventHandler);
		return () => {
			SaveSignatureEvent.unRegisterHandler(key);
		};
	}, [
		canvasRef,
		isSignerFlow,
		previousValue,
		saveSignature,
		setIsSignatureDrawn,
		setPreviousValue,
		tabOpened,
	]);

	return (
		<div className="signature-pad-wrapper">
			<StyledMessage>{t('esign-pilet-ui:signatureAnnotationMessage')}</StyledMessage>
			<div className="signature-draw-canvas-wrapper">
				<StyledSignatureCanvasWrapper className="signature-draw-wrapper">
					<ESignatureCanvas
						ref={canvasRef}
						canvasProps={{ ...{ width: canvasWidth, height: canvasDimesions.height } }}
						onEnd={onSignEnd}
						data-testid="signature-canvas-pad"
						penColor={penColor}
						minWidth={2}
					/>
				</StyledSignatureCanvasWrapper>
				{isSignatureDrawn &&
					(isSignerFlow ? (
						<Button
							type="link"
							onClick={clearSignature}
							ref={clearRef}
							id="signature-draw-clear-link"
							data-testid="signature-draw-clear-link"
							className="signature-pad-clear-link"
							tabIndex={SignatureDrawerIndexes.DrawClearButton}
							style={{
								position: 'relative',
								top: `-${canvasDimesions.height}px`,
								float: 'right',
								marginRight: '10px',
							}}
						>
							{t('esign-pilet-ui:clear')}
						</Button>
					) : (
						<StyledClearSignature
							onClick={clearSignature}
							ref={clearRef}
							data-testid="signature-draw-clear-link"
						>
							{t('esign-pilet-ui:clear')}
						</StyledClearSignature>
					))}
			</div>
		</div>
	);
};
